import React, {Component, useEffect, useState} from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import {Line} from 'react-chartjs-2';
import axios from "../utils/axios";
import ReactApexChart from 'react-apexcharts';
import {merge} from "chart.js/helpers";
import BaseOptionChart from "./chart/BaseOptionChart";
import generate from "shortid";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);


export default function WeightChart() {
    const [label , setLabel] = useState("")
    const [weight , setWeight] = useState("")
    const [noData , setNoData] = useState(false)
    const CHART_DATA = [{
        name: 'وزن شما',
        data:weight
    }];
    const chartOptions = merge(BaseOptionChart(), {
        chart: {
            type: 'area',
            height: 350,
            style: {
                fontSize:  '14px',
                fontWeight:  'bold',
                fontFamily:  'YekanBakh',
                color:  '#263238'
            },
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            curve: 'smooth'
        },
        labels:label,
        yaxis: {
            opposite: true
        },
        legend: {
            horizontalAlign: 'center'
        }
});
    const getData = async () => {
        return await axios.post('/chart-data');
    }
    useEffect(()=>{
        getData().then((response) => {
            setWeight(response.data.weights);
            setLabel(response.data.labels);
        }).catch(()=>{
            setNoData(true)
        })
    },[])

    return (
        <>
            <h1 className="chart-weighing-title">نمودار وزن کشی</h1>
            <h1 className="chart-weighing-title fw-bold">{noData ? "تا کنون وزن کشی ثبت نشده است" : ""}</h1>
            <ReactApexChart type="area" series={CHART_DATA} options={chartOptions} height={noData ? 0 : 240}/>
        </>
    );
}
